import React, { useState } from 'react';

function CheckoutPage({ cart, setCurrentPage, onOrderSuccess }) {
  const [formData, setFormData] = useState({
    customerName: '',
    customerPhone: '',
    customerEmail: '',
    deliveryAddress: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.customerName || !formData.customerPhone || !formData.customerEmail || !formData.deliveryAddress) {
      setError('Please fill in all fields');
      return;
    }

    if (cart.length === 0) {
      setError('Your cart is empty');
      return;
    }

    // Calculate total
    const totalPrice = cart.reduce((sum, item) => sum + item.price, 0);

    // Prepare order data
    const orderData = {
      customerName: formData.customerName,
      customerPhone: formData.customerPhone,
      customerEmail: formData.customerEmail,
      deliveryAddress: formData.deliveryAddress,
      items: cart.map(item => ({
        productId: item._id,
        productName: item.name,
        price: item.price,
        quantity: 1
      })),
      totalPrice: totalPrice,
      status: 'Pending'
    };

    try {
      setLoading(true);
      setError(null);

      // Send order to backend
      const response = await fetch('https://dishamedicalstore-backend.onrender.com/api/orders', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderData)
      });

      if (!response.ok) {
        throw new Error('Failed to place order');
      }

     await response.json();
      
      // Show success
      setSuccess(true);

       // Call onOrderSuccess callback
      if (onOrderSuccess) {
        onOrderSuccess(orderData);
      }
      

      //clear form data
      setFormData({
        customerName: '',
        customerPhone: '',
        customerEmail: '',
        deliveryAddress: ''
      });
      
      // Redirect to home after 3 seconds
      setTimeout(() => {
        setCurrentPage('home');
      }, 3000);

    } catch (err) {
      console.error('Error placing order:', err);
      setError('Failed to place order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const totalPrice = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <main className="checkout-page">
      {success ? (
        <div className="success-message">
          <h2>✅ Order Placed Successfully!</h2>
          <p>Thank you for your order, {formData.customerName}!</p>
          <p>We will contact you soon at <strong>{formData.customerPhone}</strong></p>
          <p className="redirect-message">Redirecting to home...</p>
        </div>
      ) : (
        <>
          <h2>Checkout</h2>
          
          {/* Order Summary */}
          <div className="order-summary">
            <h3>Order Summary</h3>
            <div className="summary-items">
              {cart.length === 0 ? (
                <p className="empty-cart">Your cart is empty</p>
              ) : (
                <>
                  {cart.map((item, idx) => (
                    <div key={idx} className="summary-item">
                      <span>{item.name}</span>
                      <span className="item-price">₹{item.price}</span>
                    </div>
                  ))}
                  <div className="summary-total">
                    <strong>Total Items: {cart.length}</strong>
                    <strong className="total-price">Total: ₹{totalPrice}</strong>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Error Message */}
          {error && <p className="error-message">❌ {error}</p>}

          {/* Checkout Form */}
          <form onSubmit={handleSubmit} className="checkout-form">
            <h3>Delivery Information</h3>
            
            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="customerName"
                placeholder="Enter your full name"
                value={formData.customerName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number *</label>
              <input
                type="tel"
                name="customerPhone"
                placeholder="Enter your phone number"
                value={formData.customerPhone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email"
                name="customerEmail"
                placeholder="Enter your email"
                value={formData.customerEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Delivery Address *</label>
              <textarea
                name="deliveryAddress"
                placeholder="Enter your complete delivery address"
                value={formData.deliveryAddress}
                onChange={handleChange}
                rows="4"
                required
              ></textarea>
            </div>

            <div className="checkout-info">
              <p>💳 <strong>Payment Method:</strong> Cash on Delivery</p>
              <p>📞 You will receive a call from our team to confirm your order</p>
            </div>

            <button 
              type="submit" 
              className="btn-place-order"
              disabled={loading || cart.length === 0}
            >
              {loading ? 'Processing...' : 'Place Order'}
            </button>
          </form>
        </>
      )}
    </main>
  );
}

export default CheckoutPage;